import type { ITimelineGroup } from "../../views/Timeline/useTimeline";
import { useMemo } from "react";
import { EVENT_DATE_FORMAT } from "shared/utils";
import { format, parse } from "date-fns";
import { TimelineGroupItem } from "../TimelineGroupItem/TimelineGroupItem";
import { toZonedTime } from "date-fns-tz";
import { TimelineGroupLayout } from "shared/components";
import { useTranslation } from "react-i18next";

type TimelineGroupProps = {
  timelineGroup: ITimelineGroup;
  onOpenLeadModal: (leadId: string) => void;
  onOpenBroadcastModal: (broadcastId: string, timelineItemId: string) => void;
  onOpenFormResponseModal: (surveyResponseId: string) => void;
  onOpenEventModal: (eventId: string) => void;
  loadingTimelineItemId: string;
};

export const TimelineGroup = ({
  timelineGroup,
  onOpenLeadModal,
  onOpenBroadcastModal,
  onOpenFormResponseModal,
  onOpenEventModal,
  loadingTimelineItemId,
}: TimelineGroupProps) => {
  const { t } = useTranslation("people", {
    keyPrefix: "PERSON_DETAILS_MODAL.TIMELINE",
  });
  const formattedDate = useMemo(() => {
    const itemDate = format(
      parse(timelineGroup.groupByDate, EVENT_DATE_FORMAT, new Date()),
      EVENT_DATE_FORMAT,
    );
    const today = format(new Date(), EVENT_DATE_FORMAT);
    return itemDate === today
      ? t("TODAY")
      : format(toZonedTime(timelineGroup.groupByDate, "UTC"), "MMM d");
  }, [timelineGroup.groupByDate, t]);
  return (
    <TimelineGroupLayout formattedDateString={formattedDate}>
      {timelineGroup.items.map((item, index) => (
        <TimelineGroupItem
          key={index}
          timelineItem={item}
          onOpenLeadModal={onOpenLeadModal}
          onOpenBroadcastModal={onOpenBroadcastModal}
          onOpenFormResponseModal={onOpenFormResponseModal}
          onOpenEventModal={onOpenEventModal}
          loadingTimelineItemId={loadingTimelineItemId}
        />
      ))}
    </TimelineGroupLayout>
  );
};
